export default __webpack_public_path__ + "static/media/menedcment.e5cf725c.pdf";